import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b44269bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Insurance", -1))
const _hoisted_2 = { class: "checkout-insurance" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InsuranceExtend = _resolveComponent("InsuranceExtend")!
  const _component_InsuranceRegular = _resolveComponent("InsuranceRegular")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, {
    hasError: _ctx.v$.$errors.length > 0
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isAmendmentMode && _ctx.insurances.length === 1)
          ? (_openBlock(), _createBlock(_component_InsuranceExtend, {
              key: 0,
              insurance: _ctx.insurances[0]
            }, null, 8, ["insurance"]))
          : (_openBlock(), _createBlock(_component_InsuranceRegular, {
              key: 1,
              insurances: _ctx.insurances
            }, null, 8, ["insurances"]))
      ])
    ]),
    _: 1
  }, 8, ["hasError"]))
}